import * as React from 'react';
import { SVGProps } from 'react';

const IconDraggableSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 4.5C6.33 4.5 7 3.83 7 3s-.67-1.5-1.5-1.5S4 2.17 4 3s.67 1.5 1.5 1.5zm0 2C4.67 6.5 4 7.17 4 8s.67 1.5 1.5 1.5S7 8.83 7 8s-.67-1.5-1.5-1.5zm0 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S7 13.83 7 13s-.67-1.5-1.5-1.5zm5-7c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S9 2.17 9 3s.67 1.5 1.5 1.5zm0 2C9.67 6.5 9 7.17 9 8s.67 1.5 1.5 1.5S12 8.83 12 8s-.67-1.5-1.5-1.5zm0 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S12 13.83 12 13s-.67-1.5-1.5-1.5z" />
  </svg>
);
export default IconDraggableSizeS;
